  <template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-bind:valid="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('_news.title')"
                  :rules="titleRules"
                  maxlength="120"
                  counter
                ></v-text-field>
              </v-row>
              <v-row>
                <v-textarea
                  v-model="editedItem.content"
                  :label="$t('_news.content')"
                  :rules="textRules"
                  rows="3"
                  maxlength="400"
                  counter
                ></v-textarea>
              </v-row>
              <v-row>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.date"
                      :label="$t('_news.date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      :rules="startDateRules"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.date"
                    :locale="lang"
                    :max="getEndDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-row>
              <v-row>
                <v-menu
                  ref="timeStartMenu"
                  v-model="timeMenu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.time"
                      :label="$t('_date.startTime')"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      :rules="startTimeRules"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="timeMenu1"
                    v-model="editedItem.time"
                    full-width
                    format="24hr"
                    @click:minute="$refs.timeStartMenu.save(editedItem.time)"
                  ></v-time-picker>
                </v-menu>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="save" v-bind:valid="valid">
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    dialog: Boolean,
    editedItem: Object,
    editedIndex: Number,
  },
  data() {
    return {
      mapDialog: false,
      locSelected: [{ lat: null, lon: null }],
      valid: false,
      disabled: false,
      dialog: false,
      dialogDelete: false,
      defaultItem: {
        title: "",
        content: "",
        date: "",
      },
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: null,
      y: null,
      mode: null,
      timeout: 3000,
      nameRules: [(v) => !!v || "Ad Girilmelidir"],
      titleRules: [(v) => !!v || "Başlık Girilmelidir"],
      textRules: [(v) => !!v || "Metin Girilmelidir"],
      startDateRules: [(v) => !!v || "Haber Tarihi Girilmelidir"],
      startTimeRules: [(v) => !!v || "Haber Zamanı Girilmelidir"],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu1: false,
      menu2: false,
      start: null,
      end: null,
      timeMenu1: false,
    };
  },

  computed: {
    ...mapGetters({ language: "app/language" }),
    getEndDate() {
      const today = new Date();
      let tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);
      //returns the tomorrow date
      return tomorrow.toISOString().slice(0, 10);
    },
    lang() {
      return this.language.replaceAll("_", "-");
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("common.new") + " " + this.$t("_news.news")
        : this.$t("common.edit");
    },
  },
  watch: {
    dialog(val) {
      this.$refs.form.resetValidation();
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("cancelled");

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      var startTimeAndDate = this.editedItem.date + " " + this.editedItem.time;
      if (this.$refs.form.validate()) {
        this.valid = true;
        if (this.editedIndex > -1) {
          //Object.assign(this.counties[this.editedIndex], this.editedItem);
          try {
            await this.$store.dispatch("news/update", {
              title: this.editedItem.title,
              text: this.editedItem.content,
              date: startTimeAndDate,
              id: this.editedItem.id,
              isArchived: this.editedItem.isArchived,
            });
            this.editedItem.title = "";
            this.editedItem.content = "";
            this.editedItem.date = "";
            this.editedItem.time = "";
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kayıt güncellendi.";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kayıt güncellenemedi";

            console.error(e);
          }
        } else {
          try {
            await this.$store.dispatch("news/create", {
              title: this.editedItem.title,
              text: this.editedItem.content,
              date: startTimeAndDate,
            });
            this.editedItem.title = "";
            this.editedItem.content = "";
            this.editedItem.date = "";
            this.editedItem.time = "";
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kayıt eklendi";
            this.x = "center";
            this.y = "bottom";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kayıt eklenemedi";
            console.log(e);
            this.x = "center";
            this.y = "bottom";
          }
        }
        this.$emit("confirmed", this.editedItem);
        this.close();
      }
    },
  },
};
</script>